module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('server-side-data-table', {
    attrs: {
      "url": this.url,
      "columns": this.columns,
      "extras-column-name": _vm.trans('columns.actions'),
      "storage-key": "pages-index"
    },
    scopedSlots: _vm._u([{
      key: "extras",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "btn-group"
        }, [_c('a', {
          staticClass: "btn btn-secondary btn-sm",
          attrs: {
            "href": row.data.public_url
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        }), _vm._v(_vm._s(_vm.trans('pages.view')) + "\n        ")]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "href": _vm.route('pages.edit', row.data.id)
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(_vm._s(_vm.trans('pages.edit')) + "\n        ")]), _vm._v(" "), (_vm.noDeleteSlugs.indexOf(row.data.slug) === -1) ? _c('a', {
          staticClass: "btn btn-danger btn-sm confirm-delete",
          attrs: {
            "href": _vm.route('pages.destroy', row.data.id),
            "data-method": "delete"
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]) : _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button",
            "disabled": ""
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-627f7065"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Pages.vue
// module id = 125
// module chunks = 0